import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/finance/scenarios')({
  component: () => <PageStub title="Financial Scenarios" description="What-if analysis and planning" />,
});
